export default __webpack_public_path__ + "static/media/402.22519288.png";